import { FC, useEffect, useState } from "react";
import { Box, Typography } from "@material-ui/core";
import { useLocation } from "react-router-dom";

import { Modal } from "../../components";

interface Message {
  title: string;
  content: string[];
}

const NotificationModal: FC = () => {
  const [message, setMessage] = useState<Message | null>(null);
  const location = useLocation();

  useEffect(() => {
    const { title, content } = (location.state ?? {}) as Message;
    if (!!title && content.length !== 0) {
      setMessage(location.state as Message);
    }
  }, [location.state]);

  return (
    <Modal
      open={!!message}
      onClose={() => {
        setMessage(null);
        window.history.replaceState(
          {},
          document.title,
          window.location.href.split("?")[0],
        );
      }}
      title={message ? message.title : ""}
      closeButtonText="Ok"
    >
      {message &&
        message.content.map((line, i) => (
          <Box key={i} mb={i === message.content.length - 1 ? 0 : 4}>
            <Typography variant="body1" key={i} align="center" gutterBottom>
              {line}
            </Typography>
          </Box>
        ))}
    </Modal>
  );
};

export default NotificationModal;
